<h1 mat-dialog-title>
    <mat-icon>alarm</mat-icon>
    Lembrete
</h1>
<mat-dialog-content>
    <p><strong>Contato:</strong> {{ reminder.contact?.name || 'Não informado'
        }}</p>
    <p><strong>Descrição:</strong></p>
    <p>{{ reminder.description }}</p>
    <p><strong>Data/Hora Agendada:</strong> {{ reminder.reminderDateTime |
        date:'dd/MM/yyyy HH:mm' }}</p>

    <div *ngIf="getCategoryName() as categoryName">
        <p><strong>Categoria:</strong> {{ categoryName }}</p>
    </div>

    <!-- Exemplo se fosse uma tarefa (não aplicável aqui, mas para referência) -->
    <!-- 
    <div *ngIf="reminder.type === 'TASK' && reminder.priority">
        <p><strong>Prioridade:</strong> {{ getPriorityDescription(reminder.priority) }}</p>
    </div> 
    -->

</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button (click)="close()">Fechar</button>
    <!-- Poderia adicionar um botão para ir para o contato, por exemplo -->
    <!-- <button mat-raised-button color="primary" [routerLink]="['/contacts', reminder.contact?.id]">Ver Contato</button> -->
</mat-dialog-actions>